import gql from 'graphql-tag';

const REMOVE_PRODUCT_FROM_PRICESHEET = gql`
  mutation RemoveProductFromPricesheet ($pricesheetId: String!, $productId: String!) {
    pricesheet: removeProductFromPricesheet(pricesheetId: $pricesheetId, productId: $productId) {
      price
      product {
        id,
        inRutaCode,
        inRutaShortDescriptionSpanish
      }
    }
  }
`;

export default REMOVE_PRODUCT_FROM_PRICESHEET;
